<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<v-col class="ma-0 pa-0" cols="auto">
						<v-btn id="back_clean_btn" width="auto" height="50px"
							class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
							@click="goSetting">
							{{ts('title')}}
						</v-btn>
					</v-col>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						<v-btn id="back_clean_btn" width="auto" height="50px"
							class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
							@click="goSearchBranchStore">
							{{ts('branchSearch')}}
						</v-btn>
					</v-col>
					<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
						src="@/assets/images/history_arrow.png"></v-img>
					<v-col class="ma-0 pa-0" cols="auto">
						{{'支店検索'}}
					</v-col>
				</v-row>
			</v-col>
		</v-col>

    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<v-col class="ma-0 pa-0" cols="10">
				<v-col class="ma-0 pa-0" cols="12"
					v-for="(areaData, index) in storeList" :key="index">
					<v-col class="ma-0 pa-0 pt-9 pb-2" cols="12" align="left">
						{{areaData.areaName + '(' + areaData.stores.length + ')'}}
					</v-col>
					<v-col class="ma-0 pa-0" cols="12"
						v-for="(item, index_nest) in areaData.stores" :key="index_nest" @click="goBranchAuthoritySetting(item)">
						<v-col id="user_box" class="ma-0 pa-2 pt-1 pl-9 pr-9" cols="12"
							:class="{'user_box_top': index == 0 && index_nest == 0 , 
								'user_box_bottom': index == (storeList.length -1) && index_nest == (areaData.stores.length -1)}">
							<v-row class="ma-0 pa-2 pl-0 pr-0 user_box_border" align="center">
								<v-col class="ma-0 pa-0" cols="4" align="left">
									{{item.customerName}}
								</v-col>
								<!-- <v-col class="ma-0 pa-0" cols="4" align="left">
									{{item.admin == undefined ? '管理者:(未登録)' : '管理者:' + item.admin}}
								</v-col>
								<v-col class="ma-0 pa-0" cols="4" align="left">
									{{item.shareUser == undefined ? 'シェアメンバー:(未登録)' : 'シェアメンバー:' + item.shareUser + '人'}}
								</v-col> -->
							</v-row>
						</v-col>
					</v-col>
				</v-col>
			</v-col>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import { TestBranchStoreData } from '../../whitetest/sampleData';
export default {
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		sampleData: TestBranchStoreData,
    searchResult: [],
		storeList: [],
	}),
  created() {
		this.searchResult = this.$store.getters.getStoreSearchResult;
  },
  mounted() {
    this.setResultData();
  },
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
		goSetting() {
			this.replaceRoute('/setting', {});
		},
		goSearchBranchStore() {
			this.replaceRoute('/setting/branch-search', {});
		},
    setResultData() {
      this.searchResult.forEach((item) => {
        let index = this.storeList.findIndex((r) => r.areaCd == item.areaCd);
        if(index == -1){
          let stores = [];
          stores.push(item);
          this.storeList.push({areaCd: item.areaCd, areaName: item.areaName, stores: stores});
        } else {
          console.log(this.storeList[index]);
          this.storeList[index].stores.push(item);
        }
      });
    },
		goBranchAuthoritySetting(item) {
			this.pushRoute('/setting/branch-search/authority', {storeName: item.customerName, unisCustomerCd: item.unisCustomerCd});
		},
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
	position: sticky;
	top: 0;
	z-index: 5;
}
#header_height {
	height: 50px;
}
#user_box {
	background-color: #383838;
	cursor: pointer;
}
.user_box_top {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
.user_box_bottom {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}
.user_box_border {
	border-bottom: 1px solid #606060;
}
#user_box_alone {
	background-color: #383838;
	border-radius: 4px;
}
</style>